import { ArrowDropDown } from "@mui/icons-material";
import { Button, Menu, MenuItem, Stack } from "@mui/material";
import { OneTimeSeatWarningDialog } from "components/OneTimeSeatWarningDialog";
import { User } from "data/interfaces";
import { useState } from "react";

interface RoleActionsProps {
  selectedUsers: User[];
  isOneTimeSeat: boolean;
  onEnableAllRoles: (users: User[]) => void;
  onDisableAllRoles: (users: User[]) => void;
}

export default function RoleActions({
  selectedUsers,
  isOneTimeSeat,
  onEnableAllRoles,
  onDisableAllRoles,
}: RoleActionsProps) {
  const [actionsAnchorEl, setActionsAnchorEl] = useState(null);
  const [enableWarningOpen, setEnableWarningOpen] = useState(false);
  const [disableWarningOpen, setDisableWarningOpen] = useState(false);

  const openActionsMenu = (event: any) =>
    setActionsAnchorEl(event.currentTarget);
  const closeActionsMenu = () => setActionsAnchorEl(null);

  const handleEnableAllRoles = (event: any) => {
    closeActionsMenu();
    if (isOneTimeSeat) {
      setEnableWarningOpen(true);
    } else {
      onEnableAllRoles(selectedUsers);
    }
  };

  const handleDisableAllRoles = (event: any) => {
    closeActionsMenu();
    if (isOneTimeSeat) {
      setDisableWarningOpen(true);
    } else {
      onDisableAllRoles(selectedUsers);
    }
  };

  return (
    <Stack spacing={2} direction="row">
      <Button
        color="default"
        disabled={!selectedUsers.length}
        variant="outlined"
        startIcon={<ArrowDropDown />}
        onClick={openActionsMenu}
      >
        Actions
      </Button>
      <Menu
        anchorEl={actionsAnchorEl}
        keepMounted
        open={Boolean(actionsAnchorEl)}
        onClose={closeActionsMenu}
      >
        <MenuItem onClick={handleEnableAllRoles}>Enable all roles</MenuItem>
        <MenuItem onClick={handleDisableAllRoles}>Disable all roles</MenuItem>
      </Menu>
      <OneTimeSeatWarningDialog
        open={enableWarningOpen}
        onClose={() => setEnableWarningOpen(false)}
        onConfirm={() => {
          onEnableAllRoles(selectedUsers);
          setEnableWarningOpen(false);
        }}
        variant="assign"
      />
      <OneTimeSeatWarningDialog
        open={disableWarningOpen}
        onClose={() => setDisableWarningOpen(false)}
        onConfirm={() => {
          onDisableAllRoles(selectedUsers);
          setDisableWarningOpen(false);
        }}
        variant="unassign"
      />
    </Stack>
  );
}
